// Lv2: 段階予告メッセージのテンプレート生成

import { Lv2Task } from '../types';

export type Stage = 'pre30' | 'pre15' | 'pre5' | 'onTime';

export function generateLv2Message(task: Lv2Task, stage: Stage): string {
  // カスタムメッセージがあれば優先
  if (task.customMessages?.[stage]) {
    return task.customMessages[stage]!;
  }
  const title = task.title;
  switch (stage) {
    case 'pre30':
      return `あと30分で${title}だよ。覚えてる？`;
    case 'pre15':
      return `あと15分で${title}。そろそろ準備しようね。`;
    case 'pre5':
      return `あと5分で${title}！靴とか持ち物、確認してね。`;
    case 'onTime':
      return `${title}の時間だよ！`;
  }
}

/** Lv3でClaudeに渡す対話用システムプロンプト */
export function buildLv3SystemPrompt(taskTitle: string, stage: Stage, ignoreCount: number): string {
  return `あなたは家庭で子どもに優しく声をかけるアシスタントです。
今は「${taskTitle}」の${stageLabel(stage)}タイミングです。
これまでこの子は今日${ignoreCount}回呼びかけを無視 or 拒否しています。
- 1〜2文の短い日本語で返してください
- 親しみやすく、命令口調ではなく
- ignoreCount が増えるほど、少しトーンを強めて
- 「えらいね」「あと少し」など励ましを混ぜて

応答内容を解釈する場合は、以下のJSON形式で返してください：
{ "verdict": "positive" | "negative" | "ambiguous" | "silent", "reply": "子どもへの返事" }`;
}

function stageLabel(stage: Stage): string {
  switch (stage) {
    case 'pre30':
      return '30分前予告';
    case 'pre15':
      return '15分前予告';
    case 'pre5':
      return '5分前予告';
    case 'onTime':
      return '開始時刻';
  }
}
